import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

function CardElementField({ setFieldValue, setFieldTouched, error, touched, ...props }) {
  const [innerError, setInnerError] = React.useState('');

  function handleChange(data) {
    const errorMessage = data?.error?.message;
    const value = data?.complete || undefined;

    setInnerError(errorMessage);
    setFieldValue(props.name, value);
  }

  function handleBlur() {
    if (!touched) {
      setFieldTouched(props.name, true, false);
    }
  }

  return (
    <TextField
      {...props}
      error={!!innerError || !!error}
      helperText={innerError || error}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}

CardElementField.propTypes = {
  options: PropTypes.object,
  name: PropTypes.string.isRequired,
  error: PropTypes.any,
  touched: PropTypes.any,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
};

export default React.memo(CardElementField);
